import { useMutation, useQueryClient } from 'react-query';
import ItemServiceApi, { BulkCreateItems } from '../../Api/item-service';

type SubmitVendorCatalogItemsParams = BulkCreateItems & {
  userId: string;
};

export const useSubmitVendorCatalogItems = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: SubmitVendorCatalogItemsParams) =>
      ItemServiceApi.createVendorItems(params.userId, { items: params.items }),
    {
      onError: async (_error, variables) => {
        await queryClient.invalidateQueries([
          'item-service-count-remaining-item',
          variables.userId,
        ]);
        await queryClient.invalidateQueries([
          'item-service-vendor-catalog-item',
          variables.userId,
        ]);
        await queryClient.invalidateQueries([
          'item-service-vendor-catalog-items-count',
          variables.userId,
        ]);
        await queryClient.invalidateQueries([
          'item-service-vendor-catalog',
          variables.userId,
        ]);
      },
    },
  );
};
